<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="-5 -5 110 110"
    class="svg-icon"
  >
    <g fill="#323232" fill-rule="nonzero">
      <circle cx="50" cy="50" r="50" :stroke="color" stroke-width="7px" />
      <text x="37" y="63" :fill="color" font-weight="bold" font-size="40">
        <slot>{{ "S" }}</slot>
      </text>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-letter",
  components: {},
})
export class IconLetter extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconLetter;
</script>
